import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "content", "hidden"];

  connect() {}

  show(event) {
    event.preventDefault();
    this.linkTarget.classList.add("hidden");
    this.contentTarget.classList.remove("hidden");
    this.hiddenTarget.classList.add("hidden");
  }
}
 